module.exports = __webpack_public_path__ + "7512eb8e7dc902bc438024d6075eee76.jpg";


//////////////////
// WEBPACK FOOTER
// ./photo.jpg
// module id = 495
// module chunks = 0